module.exports = __webpack_public_path__ + "img/BG_abstract_v2.bef3604e.png";